import MyDocumentsArchived from 'routes/client/my-documents/archived';
import MyDocumentsReadyForSignSend from 'routes/client/my-documents/ready-for-sign-send';
import MyDocumentsReceived from 'routes/client/my-documents/received';
import MyDocumentsSent from 'routes/client/my-documents/sent';
import MyDocumentsTrash from 'routes/client/my-documents/trash';

import DocumentsArchived from 'routes/client/documents/archived';
import DocumentsReadyForSignSend from 'routes/client/documents/ready-for-sign-send';
import DocumentsReceived from 'routes/client/documents/received';
import DocumentsSent from 'routes/client/documents/sent';
import DocumentsTrash from 'routes/client/documents/trash';

import DocumentActivity from 'routes/client/document-activity';
import MultipleDocumentActivity from 'routes/client/multiple-document-activity';

import DocumentsWizardStep1 from 'routes/client/documents-wizard/step-1';
import DocumentsWizardStep2 from 'routes/client/documents-wizard/step-2';
import DocumentsWizardStep3 from 'routes/client/documents-wizard/step-3';
import DocumentsWizardStep4 from 'routes/client/documents-wizard/step-4';
import DocumentsWizardStep5 from 'routes/client/documents-wizard/step-5';

import StructureGroupsList from 'routes/client/structure/groups/list';
import StructureGroupsCreate from 'routes/client/structure/groups/create';
import StructureGroupsEdit from 'routes/client/structure/groups/edit';

import StructureRolesList from 'routes/client/structure/roles/list';
import StructureRolesCreate from 'routes/client/structure/roles/create';
import StructureRolesEdit from 'routes/client/structure/roles/edit';

import StructureEmployeesList from 'routes/client/structure/employees/list';
import StructureEmployeesCreate from 'routes/client/structure/employees/create';
import StructureEmployeesImport from 'routes/client/structure/employees/import';
import StructureEmployeesEdit from 'routes/client/structure/employees/edit';

import ColleagueLeavesList from 'routes/client/colleague-leaves';
import LeavesList from 'routes/client/my-leaves/list';
import LeavesPrevious from 'routes/client/my-leaves/previous';
import LeavesCreate from 'routes/client/my-leaves/create';
import MyHourlyAbsences from 'routes/client/my-hourly-absences/list';
import MyHourlyAbsencesCreate from 'routes/client/my-hourly-absences/create';
import MyWorkTripsList from 'routes/client/my-work-trips/list';
import MyWorkTripsCompletedList from 'routes/client/my-work-trips/list-completed';
import MyWorkTripsCalendar from 'routes/client/my-work-trips/calendar';
import LeavesSchedule from 'routes/client/leaves/list';
import LeavesScheduleCompleted from 'routes/client/leaves/list-completed';
import LeavesCalendar from 'routes/client/leaves/calendar';
import InsertManuallyLeave from 'routes/client/leaves/create';
import EditManuallyLeave from 'routes/client/leaves/edit';
import LeavesStatistics from 'routes/client/leaves/statistics';
import HourlyAbsences from 'routes/client/hourly-absences/list';
import CreateHourlyAbsences from 'routes/client/hourly-absences/create/index';
import HealthAndSafetyTrainingList from 'routes/client/health-and-safety-training/list';
import HealthAndSafetyTrainingListCompleted from 'routes/client/health-and-safety-training/list-completed';
import HealthAndSafetyTrainingCreate from 'routes/client/health-and-safety-training/create';
import WorkTripsList from 'routes/client/work-trips/list';
import WorkTripsCompletedList from 'routes/client/work-trips/list-completed';
import WorkTripsCreate from 'routes/client/work-trips/create';
import WorkTripsCalendar from 'routes/client/work-trips/calendar';

import StructureScenarios from 'routes/client/structure/scenarios';
import StructureMultiActions from 'routes/client/structure/multi-actions';
import StructureOvertime from 'routes/client/structure/overtime';

import TrainingMaterials from 'routes/client/training-materials';

import Reports from 'routes/client/reports/documents';
import LeavesReports from 'routes/client/reports/leaves';
import LeavesReportsSummary from 'routes/client/reports/leaves-summary';
import LeavesReportsList from 'routes/client/reports/leaves-list';
import LeavesAvailability from 'routes/client/reports/leaves-availability';
import EmployeeData from 'routes/client/reports/employee-data';
import LeavesReportsFormSixtySeven from 'routes/client/reports/leaves-form-sixty-seven';
import ClientHourlyAbsencesReports from 'routes/client/reports/hourly-absences';
import HealthAndSafetyTrainingReports from 'routes/client/reports/health-and-safety-training';
import WorkTripsReports from 'routes/client/reports/work-trips';
import MunicipalityReports from 'routes/client/reports/municipality';
import ClientDocumentsByAction from 'routes/client/reports/documents-by-action';
import Downloads from 'routes/client/archives';
import DownloadArchive from 'routes/client/archives/archives';
import Home from 'routes/client/home';
import { PermissionKeys } from 'store/types';
import { IRouteConfig } from './common-routes';

const routes: IRouteConfig[] = [
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/archives/:id',
    component: DownloadArchive,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/archives',
    component: Downloads,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/reports/leaves',
    component: LeavesReports,
  },
  {
    path: '/reports/leaves-summary',
    component: LeavesReportsSummary,
  },
  {
    path: '/reports/leaves-list',
    component: LeavesReportsList,
  },
  {
    path: '/reports/leaves-availability',
    component: LeavesAvailability,
  },
  {
    path: '/reports/employee-data',
    component: EmployeeData,
  },
  {
    path: '/reports/leaves-form-76',
    component: LeavesReportsFormSixtySeven,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV && PermissionKeys.CAN_MANAGE_LEAVES,
  },
  {
    path: '/reports/hourly-absences',
    component: ClientHourlyAbsencesReports,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV && PermissionKeys.CAN_MANAGE_HOURLY_ABSENCES,
  },
  {
    path: '/reports/health-and-safety-training',
    component: HealthAndSafetyTrainingReports,
    permissionGrantingAccess:
      PermissionKeys.CAN_SEE_EMPLOYER_NAV && PermissionKeys.CAN_MANAGE_HEALTH_AND_SAFETY_TRAINING,
  },
  {
    path: '/reports/work-trips',
    component: WorkTripsReports,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV && PermissionKeys.CAN_MANAGE_WORK_TRIPS,
  },
  {
    path: '/reports/documents',
    component: Reports,
  },
  {
    path: '/reports/documents-by-action',
    component: ClientDocumentsByAction,
  },
  {
    path: '/reports/municipality',
    component: MunicipalityReports,
  },
  {
    path: '/my-leaves/create',
    component: LeavesCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-leaves/previous',
    component: LeavesPrevious,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-leaves',
    component: LeavesList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-hourly-absences/create',
    component: MyHourlyAbsencesCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-hourly-absences',
    component: MyHourlyAbsences,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-work-trips/completed',
    component: MyWorkTripsCompletedList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-work-trips/calendar',
    component: MyWorkTripsCalendar,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-work-trips',
    component: MyWorkTripsList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/colleague-leaves',
    component: ColleagueLeavesList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/leaves/completed/create',
    component: InsertManuallyLeave,
    permissionGrantingAccess: PermissionKeys.CAN_MANAGE_MANUALLY_ADDED_LEAVES,
  },
  {
    path: '/leaves/manually/edit/:id',
    component: EditManuallyLeave,
    permissionGrantingAccess: PermissionKeys.CAN_MANAGE_MANUALLY_ADDED_LEAVES,
  },
  {
    path: '/leaves/calendar',
    component: LeavesCalendar,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/leaves/statistics',
    component: LeavesStatistics,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/leaves/completed',
    component: LeavesScheduleCompleted,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/leaves',
    component: LeavesSchedule,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/hourly-absences/create',
    component: CreateHourlyAbsences,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/hourly-absences',
    component: HourlyAbsences,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/health-and-safety-training/create',
    component: HealthAndSafetyTrainingCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/health-and-safety-training/completed',
    component: HealthAndSafetyTrainingListCompleted,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/health-and-safety-training',
    component: HealthAndSafetyTrainingList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/work-trips/create',
    component: WorkTripsCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/work-trips/completed',
    component: WorkTripsCompletedList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/work-trips/calendar',
    component: WorkTripsCalendar,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/work-trips',
    component: WorkTripsList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/my-documents/archived',
    component: MyDocumentsArchived,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-documents/ready-for-sign-send',
    component: MyDocumentsReadyForSignSend,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-documents/received',
    component: MyDocumentsReceived,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-documents/sent',
    component: MyDocumentsSent,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/my-documents/trash',
    component: MyDocumentsTrash,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYEE_NAV,
  },
  {
    path: '/documents/archived',
    component: DocumentsArchived,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/documents/trash',
    component: DocumentsTrash,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/documents/ready-for-sign-and-send',
    component: DocumentsReadyForSignSend,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/documents/received',
    component: DocumentsReceived,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/documents/sent',
    component: DocumentsSent,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/document-activity/:id',
    component: DocumentActivity,
  },
  {
    path: '/multiple-document-activity/:id',
    component: MultipleDocumentActivity,
  },
  {
    path: '/documents-wizard/step-1',
    component: DocumentsWizardStep1,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-2',
    component: DocumentsWizardStep2,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-3/:id',
    component: DocumentsWizardStep3,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-3',
    component: DocumentsWizardStep3,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-4/:id',
    component: DocumentsWizardStep4,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-4',
    component: DocumentsWizardStep4,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-5/:id',
    component: DocumentsWizardStep5,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/documents-wizard/step-5',
    component: DocumentsWizardStep5,
    permissionGrantingAccess: PermissionKeys.CAN_CREATE_DOCUMENTS,
  },
  {
    path: '/structure/groups/edit/:id',
    component: StructureGroupsEdit,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/groups/create',
    component: StructureGroupsCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/groups',
    component: StructureGroupsList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/roles/edit/:id',
    component: StructureRolesEdit,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/roles/create',
    component: StructureRolesCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/roles',
    component: StructureRolesList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/employees/edit/:id',
    component: StructureEmployeesEdit,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/employees/create',
    component: StructureEmployeesCreate,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/employees/import',
    component: StructureEmployeesImport,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/employees',
    component: StructureEmployeesList,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/scenarios',
    component: StructureScenarios,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/multi-actions/:id',
    component: StructureMultiActions,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/multi-actions',
    component: StructureMultiActions,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV,
  },
  {
    path: '/structure/overtimes',
    component: StructureOvertime,
    permissionGrantingAccess: PermissionKeys.CAN_SEE_EMPLOYER_NAV && PermissionKeys.CAN_MANAGE_LEAVES,
  },
  {
    path: '/training-materials',
    component: TrainingMaterials,
  },
].map(route => ({
  ...route,
  isExact: true,
  isPrivate: true,
  is2FaProtected: true,
}));

export default routes;
